/**
 * Countdown to a capsule unlocking.
 *
 * The numbers change without animation — a ticking, sliding counter would turn
 * waiting into a game, and the point is that it is not one.
 */

import { countdown } from '../js/dates.js'

export function renderCountdown(utc) {
  const left = countdown(utc)

  if (left === null) {
    return '<p class="countdown countdown--done">It is open.</p>'
  }

  // One unit at a time, big and mono: "57 DAYS REMAINING" reads as a fact,
  // where "57 d 4 h 12 min" reads as a stopwatch.
  const [value, unit] =
    left.days > 0
      ? [left.days, left.days === 1 ? 'DAY' : 'DAYS']
      : left.hours > 0
        ? [left.hours, left.hours === 1 ? 'HOUR' : 'HOURS']
        : [left.minutes, left.minutes === 1 ? 'MINUTE' : 'MINUTES']

  return `
    <p class="countdown">
      <b>${value}</b><span>${unit} REMAINING</span>
    </p>
  `
}

/** Re-renders a countdown once a minute; returns a stop function. */
export function startCountdown(element, utc, onDone) {
  const tick = () => {
    element.innerHTML = renderCountdown(utc)

    if (countdown(utc) === null) {
      stop()
      onDone?.()
    }
  }

  const timer = window.setInterval(tick, 60000)
  const stop = () => window.clearInterval(timer)

  tick()

  return stop
}
